<template>
  <div>
    <ul class="products columns-4 seasidetms_products col-md-12">
      <product-tile
        v-for="(product, index) in products"
        :key="product.slug"
        :product="product"
        :detailsEnabled="false"
        :index="index"
      />
    </ul>
  </div>
</template>

<script>
import ProductTile from '@/components/product/ProductTile'

export default {
  name: 'AccesoriesProducts',
  components: { ProductTile },
  props: {
    products: {
      type: Array,
      required: true,
      default: () => {
        return []
      },
    },
  },
}
</script>

<style></style>
